import React from 'react';
import {Col, Row, Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Color } from 'services';
import { docButton } from './documentForm';

export const bankDetails = (kycDetails, handleUpdateDetails, handleIfscUpdate, compareAcNo,
     handleUploadChange, beforeUpload, handleDocClick, handleEditCommentClick
    ) => (
    <div style={{width: "100%"}}>
        <Row className="m-t-20">
            <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                <div className='text-xs color-black m-b-5 bold-600' >Beneficiary Name <span style={{color:Color.red}}>*</span></div>
                <Input onChange={(e) => handleUpdateDetails(e.target.value.replace(/[^a-zA-Z ]/g, ''), 'beneficiaryName')}
                disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
                value={kycDetails.beneficiaryName} placeholder="Enter Beneficiary of the bank account" className='radius-5 kyc-input-fields' style={{background:Color.lightGrey, border:'none'}}/>
            </Col>
            <Col xs={{ span: 24,}} md={{ span: 11, offset: 1 }} style={{width: '100%'}} >
                <div className='text-xs color-black m-b-5 bold-600' >Branch IFSC Code <span style={{color:Color.red}}>*</span></div>
                <Input 
                    onChange={(e) => {
                        const val = e.target.value.toUpperCase().trim();
                        if (val.length <= 11) {
                            handleUpdateDetails(val, 'ifsc');
                        }
                    }}
                    maxLength={11}
                    onBlur={e => handleIfscUpdate(e)} 
                    disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
                    value={kycDetails.ifsc} 
                    placeholder="Enter IFSC Code of the account" 
                    className='radius-5 kyc-input-fields' 
                    style={{background:Color.lightGrey, border:'none'}}
                />
                {kycDetails.ifsc && kycDetails.ifscValid  === false ? <div className="text-xs red bold-600">Enter a valid IFSC code (e.g., SBIN0001234).</div> : null}
            </Col>
        </Row>
        <Row className="m-t-20">
            <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                <div className='text-xs color-black m-b-5 bold-600' >Bank Name <span style={{color:Color.red}}>*</span></div>
                <Input disabled
                value={kycDetails.bankName} 
                placeholder="Enter Bank Name" className='radius-5 kyc-input-fields' 
                style={{background:Color.lightGrey, border:'none', color: 'black'}}/>
            </Col>
            <Col xs={{ span: 24,}} md={{ span: 11, offset: 1 }} style={{width: '100%'}} >
                <div className='text-xs color-black m-b-5 bold-600' >Branch <span style={{color:Color.red}}>*</span></div>
                <Input disabled
                value={kycDetails.branch} placeholder="Enter Branch Name" className='radius-5 kyc-input-fields' 
                style={{background:Color.lightGrey, border:'none', color: 'black'}}/>
            </Col>
        </Row>
        <Row className="m-t-20">
            <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                <div className='text-xs color-black m-b-5 bold-600' >Account Number <span style={{color:Color.red}}>*</span></div>
                <Input.Password 
                iconRender={visible => (visible ? <EyeOutlined style={{ fontSize: '20px' }} /> : <EyeInvisibleOutlined style={{ fontSize: '20px' }} />)}
                onChange={(e) => {const value = e.target.value.replace(/\D/g, ''); handleUpdateDetails(value, 'accNoHidden')}}  onContextMenu={e => e.preventDefault()}
                disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
                onBlur={() => compareAcNo()}
                value={kycDetails.accNoHidden} placeholder="Enter Account Number" className='radius-5 kyc-input-fields' style={{background:Color.lightGrey, border:'none'}}/>
            </Col>
            <Col xs={{ span: 24,}} md={{ span: 11, offset: 1 }} style={{width: '100%'}} >
                <div className='text-xs color-black m-b-5 bold-600' >Re-enter Account Number <span style={{color:Color.red}}>*</span></div>
                <Input.Password 
                iconRender={visible => (visible ? <EyeOutlined style={{ fontSize: '20px' }} /> : <EyeInvisibleOutlined style={{ fontSize: '20px' }} />)}
                onChange={(e) => {const value = e.target.value.replace(/\D/g, ''); handleUpdateDetails(value, 'accNo')}} onContextMenu={e => e.preventDefault()}
                disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
                onBlur={() => compareAcNo()}
                value={kycDetails.accNo} placeholder="Enter Verify Account Number" className='radius-5 kyc-input-fields' style={{background:Color.lightGrey, border:'none'}}/>
                {kycDetails.accNoHidden && kycDetails.accNo && kycDetails.accNoMatch  === false ? <div className="text-xs red bold-600">Account numbers do not match</div> : null}
            </Col>
        </Row>
        <Row className="m-t-20">
            <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
                {docButton("Upload Cancelled Cheque", true, kycDetails, handleUploadChange, beforeUpload, 
                'cancelled_cheque', handleUpdateDetails, handleDocClick, handleEditCommentClick)}
            </Col>
            <Col xs={{ span: 24,}} md={{ span: 11, offset: 1 }} style={{width: '100%'}} >
               
            </Col>
        </Row>

    </div>
)